import { DeliveredType } from "../types";

const labelTextStyle: React.CSSProperties = {
  display: "block",
  fontSize: "14px",
  fontWeight: 600,
  marginBottom: "8px",
  color: "var(--text-primary)",
};

const selectStyle: React.CSSProperties = {
  width: "100%",
  minHeight: "48px",
  padding: "14px 16px",
  borderRadius: "16px",
  border: "1px solid var(--border)",
  outline: "none",
  background: "var(--surface-alt)",
  color: "var(--text-primary)",
  fontSize: "15px",
};

export function DeliveryTypeSelect({
  value,
  onChange,
  allowAll = false,
}: {
  value: DeliveredType;
  onChange: (value: DeliveredType) => void;
  allowAll?: boolean;
}) {
  return (
    <label style={{ display: "block", width: "100%" }}>
      <span style={labelTextStyle}>Tipo de entrega</span>

      <select
        value={value}
        onChange={(event) => onChange(event.target.value as DeliveredType)}
        style={selectStyle}
      >
        <option value="D">Domicilio</option>
        <option value="S">Sucursal</option>
        {allowAll ? <option value="ALL">Domicilio + Sucursal</option> : null}
      </select>
    </label>
  );
}